import React, { useState, useEffect } from 'react';
import {
  shape, string, func, object, oneOfType,
} from 'prop-types';
import SharedScript, { Adobe, Qualtrics, ClickToChat } from '@americanexpress/shared-scripts';

const sharedScriptMap = {
  adobe: Adobe,
  qualtrics: Qualtrics,
  clickToChat: ClickToChat,
};

const DelayRender = ({
  config: {
    name,
    component = '',
    delay,
    ...rest
  },
}) => {
  const [shouldRender, setShouldRender] = useState(false);
  const ScriptToRender = component
    || sharedScriptMap[name]
    || SharedScript;

  useEffect(() => {
    setTimeout(() => { setShouldRender(true); }, delay);
  }, [delay]);

  return shouldRender
    // eslint-disable-next-line react/jsx-props-no-spreading -- Needed to pass varying config props from parent
    ? <ScriptToRender name={name} {...rest} />
    : null;
};

DelayRender.propTypes = {
  config: shape({
    name: string,
    delay: string,
    component: oneOfType([func, object]),
  }),
};

export default DelayRender;
